import React from 'react'
import { useSelector } from 'react-redux'
import { Meta, User, ShareButtons } from '../../../components'
import { useInternationalization } from '../../../features/i18n'
import { useViewport } from '../../../utils'
import ActionButtons from './action-buttons'

const Sidebar = () => {
  const blog = useSelector(state => state.blog.data)
  const { translate, language } = useInternationalization()
  const { isOfficial, isLoggedIn } = useSelector(state => state.account)
  const { isDesktop } = useViewport()

  const {
    organization_id,
    organization,
    organization_logo,
    category,
    approach_rendered,
    issue_rendered,
    // audience_rendered
  } = blog

  const categoryRendered = category ? (category[language.name] ? category[language.name] : String(category)) : "Berita, Bahan"

  return (
    <div className="w-full lg:pt-12">
      <div className="flex flex-wrap lg:block">
        <div className="w-full order-2 lg:order-1">
          {
            (isLoggedIn && !isOfficial && isDesktop) && <>
              <ActionButtons />
              <hr className="my-5 lg:my-10"/>
            </>
          }
        </div>
        <div className="order-1 w-full lg:order-2">
          <div className="hidden lg:block mb-8 lg:w-auto">
            <User
              name={organization}
              image={organization_logo}
              organizationId={organization_id}
            />
          </div>
          <div className="flex flex-wrap -mx-2 lg:mx-0 lg:block">
            <div className="w-1/2 lg:w-auto px-2 lg:px-0 mb-4 lg:mb-8">
              <Meta
                label={translate('GENERAL', 'category')}
                value={categoryRendered}
              />
            </div>
            <div className="w-1/2 lg:w-auto px-2 lg:px-0 mb-4 lg:mb-8">
              <Meta
                label={translate('APPROACH', 'singular')}
                value={approach_rendered[language.name]}
              />
            </div>
            <div className="w-1/2 lg:w-auto px-2 lg:px-0 mb-4 lg:mb-8">
              <Meta
                label={translate('ISSUE', 'plural')}
                value={issue_rendered[language.name]}
              />
            </div>
            {/* <div className="w-1/2 lg:w-auto px-2 lg:px-0 mb-6 lg:mb-0">
              <Meta
                label={translate('GENERAL', 'suitable_for')}
                value={audience_rendered[language.name]}
              />
            </div> */}
          </div>
          <hr className="hidden lg:block my-5 lg:my-10"/>
          <div className="w-full lg:hidden">
            <User name={organization} />
            <hr className="my-6"/>
          </div>
        </div>
      </div>
      {
        isDesktop &&
        <>
          <div className="mb-5">
            <p className="text-sm lg:text-xs font-bold mb-5 text-center lg:text-left mt-2 lg:mt-0">Share this blog</p>
            <ShareButtons url={window.location.href}/>
          </div>
          <hr className="my-8 lg:hidden"/>
        </>
      }
    </div>
  )
}

export { Sidebar }
